import React, { useContext, useState } from 'react';
import EADialog from '../../../components/common/EADialog';
import FeedBackPopUp from '../../../components/FeedBackPopUp';
import i18next from 'i18next';
import { useRequestLoading } from '../../../components/common/hooks/useRequestLoading';
import { Controller, useFormContext } from 'react-hook-form';
import { ERROR } from '../../../services/common/Constants';
import { Context } from '../../../states/Store';
import EAIcon from '../../../components/common/EAIcon';
import { Grid, TextField } from '@mui/material';
import EAInputBloc from '../../../components/common/EAInputBloc';
import style from './style';

const commentMaxLength = 100;

const ArchiveDialog = ({
  FORM_ID,
  callback,
  open,
  onClose,
  traductions
}) => {
  const { classes } = style();
  const [, dispatch] = useContext(Context);

  const { isRequestLoading, startLoading, stopLoading } = useRequestLoading();
  const [isDeactivated, setIsDeactivated] = useState(false);
  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useFormContext();

  const handleClose = () => {
    onClose?.();
    setTimeout(() => {
      setIsDeactivated(false);
    }, [300])
  };

  const archive = async (data) => {
    try {
      startLoading();
      await callback(data);
      setIsDeactivated(true);
      reset({
        motif: '',
      });
      stopLoading();
    } catch (error) {
      dispatch({
        type: 'ALERT',
        alert: { type: ERROR, msg: 'STOP_CONTEXT_ERROR' },
      });
    }
  }

  return (
    <EADialog
      isOpen={open}
      onCancel={handleClose}
      crossVisible={false}
      hasActions={!isDeactivated}
      validateBtnLabel={'approve'}
      fullWidth
      maxWidth="sm"
      isValidateDisabled={isRequestLoading}
      formId={FORM_ID}
    >
      {!isDeactivated ? (
        <form id={FORM_ID} onSubmit={handleSubmit(archive)}>
          <div className={classes.titleHeader}>
            <EAIcon icon={'inventory'} className={classes.topHeaderIcon} />
            <div className={classes.archiveTitle}>
              {traductions.title}
            </div>
            <div className={classes.archiveSubTitle}>
              {traductions.subTitle}
            </div>
          </div>
          <Grid container>
            <Grid item xs={12}>
              <EAInputBloc label={`${i18next.t('dossierSheet.comment')}`}>
                <Controller
                  control={control}
                  name="motif"
                  rules={{
                    maxLength: {
                      value: commentMaxLength,
                      message: i18next.t('infos.E011_VAR', {
                        input: i18next.t('TheComment'),
                        maxLength: commentMaxLength,
                      }),
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      variant="outlined"
                      fullWidth
                      {...field}
                      multiline
                      minRows={2}
                      maxRows={5}
                      error={!!errors.motif}
                      helperText={!!errors.motif ? errors.motif.message : ''}
                    />
                  )}
                />
              </EAInputBloc>
            </Grid>
          </Grid>
        </form>
      ) : (
        <FeedBackPopUp
          onClick={onClose}
          title={traductions.feedback.title}
          imgSrc={'inventory'}
          content={
            <>
              {traductions.feedback.message}&nbsp;
              <br />
              {traductions.feedback.tip}
            </>
          }
        />
      )}
    </EADialog>
  );
};

export default ArchiveDialog;
